/**
 * @description Ações relacionadas a manipulação de casos no sistema
 * @author Bene Lemuel Dantas Gondim
 * @file casosActions.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

export const CASO_SUCESSO = 'CASO_SUCESSO'
export const CASO_ERROR = 'CASO_ERROR'
export const VESTIGIO_CASO_SUCESSO = 'VESTIGIO_CASO_SUCESSO'
export const VESTIGIO_CASO_ERROR = 'VESTIGIO_CASO_ERROR'
export const SET_PROCESSANDO_FETCH_CASOS = 'SET_PROCESSANDO_FETCH_CASOS'
export const FETCH_CASOS_DO_SETOR = 'FETCH_CASOS_DO_SETOR'
export const SET_VESTIGIOS_CASO = 'SET_VESTIGIOS_CASO'
export const SET_SOLICITACOES_CASO = 'SET_SOLICITACOES_CASO'
export const SET_PERICIANDOS_CASO = 'SET_PERICIANDOS_CASO'
export const SET_CADAVERES_CASO = 'SET_CADAVERES_CASO'
export const SET_LOCAIS_CASO = 'SET_LOCAIS_CASO'
export const SET_PROCESSANDO_VESTIGIOS_CASO = 'SET_PROCESSANDO_VESTIGIOS_CASO'
export const SET_PROCESSANDO_CADAVERES_CASO = 'SET_PROCESSANDO_CADAVERES_CASO'
export const SET_PROCESSANDO_PERICIANDOS_CASO = 'SET_PROCESSANDO_PERICIANDOS_CASO'
export const SET_PROCESSANDO_SOLICITACOES_CASO = 'SET_PROCESSANDO_SOLICITACOES_CASO'
export const SET_PROCESSANDO_LOCAIS_CASO = 'SET_PROCESSANDO_LOCAIS_CASO'

export const setProcessando = (value, variavel) => async (dispatch) => {
  switch (variavel) {
    case 'CASO': {
      dispatch({
        type: SET_PROCESSANDO_FETCH_CASOS,
        isProcessandoCasos: value,
      })
      break
    }
    case 'VESTIGIOS': {
      dispatch({
        type: SET_PROCESSANDO_VESTIGIOS_CASO,
        isProcessandoVestigios: value,
      })
      break
    }
    case 'CADAVERES': {
      dispatch({
        type: SET_PROCESSANDO_CADAVERES_CASO,
        isProcessandoCadaveres: value,
      })
      break
    }
    case 'PERICIANDOS': {
      dispatch({
        type: SET_PROCESSANDO_PERICIANDOS_CASO,
        isProcessandoPericiandos: value,
      })
      break
    }
    case 'SOLICITACOES': {
      dispatch({
        type: SET_PROCESSANDO_SOLICITACOES_CASO,
        isProcessandoSolicitacoes: value,
      })
      break
    }
    case 'LOCAIS': {
      dispatch({
        type: SET_PROCESSANDO_LOCAIS_CASO,
        isProcessandoLocais: value,
      })
      break
    }
    default:
      break
  }
}
